<template>
  <div class='institutional-qnr-intro-view is-flex-center gap-2 view p-6' :style="{height: '80vh'}">
      <div class='page-width mr-6 '>
        <img  :src="context.advisor_logo">
        <div class="pl-2">
        <h1 class='title is-3 is-extra-bold'>Behavioral Values Questionnaire</h1>
        <div class='is-flex-col gap-1 is-size-5'>
          <p>Hi <span class='weight-bold'>{{context.name}}</span>,</p>
          <p>You have been sent this questionnaire by financial advisor <span class='weight-bold'>{{context.advisor_name}}</span>.</p>
          <p class='is-size-4 is-extra-bold'>Why take the questionnaire? </p>
          <div class='is-flex'>
            <p>This questionnaire, developed in collaboration with behavioral scientists, draws from academic literature to present questions intended to reveal what is important to you. The questionnaire is not meant to be a definitive declaration of your beliefs, but rather a starting point for you to discuss your values with your financial advisor.
            <br><br>There are no right or wrong answers - people answer across the spectrum.</p>
          </div>
        </div>
        </div>
      </div>
      <div >
        <BehavioralQnrIntroGetStarted :context="context"/>
      </div>
  </div>
</template>


<script>
import BehavioralQnrIntroGetStarted from '../../components/institutional_questionnaire/BehavioralQnrIntroGetStarted.vue';

export default {
  name: 'personal-behavioral-qnr-intro-view',
  components: { BehavioralQnrIntroGetStarted },
  props: [ 'context'],
  data() {
    return { };
  },
  beforeCreate() {},
  async created() {
  },
  mounted() {},
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>
.logo {
  border: 1px dashed black;
}
img {
  max-height: 200px;
}
</style>
